<template>
    <div v-if="showModal" id="order_detail_modal" class="ui center aligned grid">
        <div class="column">
            <div id="header" class="ui top fixed menu">
                <h3>{{ order.partnerName }} 발주 내역 ({{ new Date(order.createdAt).format("yy-MM-dd HH:mm") }}) - {{ order._id }} </h3>
            </div>
            <div id="body" class="scrolling content">
                <table class="ui striped celled compact table">
                    <thead>
                        <tr>
                            <th class="collapsing">#</th>
                            <th class="collapsing">타입</th>
                            <th class="collapsing">주문날짜</th>
                            <th class="collapsing">판매처</th>
                            <th class="collapsing">상품명</th>
                            <th class="collapsing">수량</th>
                            <th>주문자</th>
                            <th>주문자연락처</th>
                            <th>수취인</th>
                            <th>수취인연락처</th>
                            <th>수취인주소</th>
                            <th class="collapsing">설치유형</th>
                            <!-- <th class="collapsing"></th> -->
                        </tr>
                    </thead>
                    <tbody v-if="order.items.length > 0">
                        <tr v-for="(item, index) in order.items" :key="item._id">
                            <td class="collapsing"> {{ index + 1 }} </td>
                            <td class="collapsing"> {{ constantNames[item.type] }} </td>
                            <td class="collapsing"> {{ new Date(item.orderedAt).format("yyyy-MM-dd(KS)") }} </td>
                            <td class="collapsing"> {{ item.seller }} </td>
                            <td class="collapsing"> {{ item.product }} </td>
                            <td class="collapsing"> {{ item.count }} </td>
                            <td class="collapsing"> {{ item.orderer }} </td>
                            <td class="collapsing"> {{ item.ordererTel }} </td>
                            <td class="collapsing"> {{ item.receiver }} </td>
                            <td class="collapsing"> {{ item.receiverTel }} </td>
                            <td class="collapsing"> {{ item.address }} </td>
                            <td class="collapsing"> {{ item.partnerMemo }} </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div id="footer" class="ui bottom fixed text menu">
                <div class="right menu">
                    <div class="item">
                        <div class="ui teal button"  @click="download">다운로드</div>
                    </div>
                    <div class="item">
                        <div class="ui button"  @click="close">닫기</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data: function() {
        return {
            showModal: 0, order: 0, _selectedWorkerId: 0, isConfirmed: 0,
        }
    },
    created: function() {
        this.showModal = false;
        this.order = this._selectedWorkerId = this.isConfirmed = 0;
        this.$event.set("openOrderDetail2", this.open);
    },
    mounted: function() {
        window.addEventListener('keyup', (e) => { if (this.showModal && e.keyCode === 27) this.close(); });
    },
    destroyed: function() {
        this.$event.clear("openOrderDetail2");
    },
    methods: {
        open(order) {
            if (order && order.items) {
                this.showModal = true;
                this.order = order;
                this._selectedWorkerId = undefined;
                this.isConfirmed = (this.order.status == this.constant.STATUS_CONFIRMED);
            }
        },
        close() {
            this.showModal = false;
        },
        findWorker(_workerId) {
            for (const center of this.centers) {
                for (const worker of center.workers) {
                    if (_workerId == worker._id) {
                        return worker;
                    }
                }
            }
        },
        download() {
            const dateText = new Date(this.order.createdAt).format("yyyyMMdd");
            this.$excel.downloadOrder(this, this.order.items, dateText + "_" + this.order.partnerName + "_발주내역");
        },
        openDetail(item) {
            switch (item.status) {
                default: this.$event.call("orderedItemDetail_open", item._id); break;
                case this.constant.STATUS_NONE: alert("확정되지 않은 주문건입니다!"); break;
                case this.constant.STATUS_COMPLETE: this.$event.call("finishedItemDetail_open", item._id); break;
                case this.constant.STATUS_CANCEL: this.$event.call("finishedItemDetail_open", item._id); break;
            }
        },
        setChange() {
            this.isChanged = true;
        },
    },
    computed: {
        area2Options: function() { return this.$store.getters.area2Options; },
        partners: function() { return this.$store.getters.partners; },
        centers: function() { return this.$store.getters.centers; },
        workers: function() { return this.$store.getters.workers; },
        constant: function() {return this.$store.getters.constant; },
        constantNames: function() {return this.$store.getters.constantNames; },
    },
}
</script>

<style>

#order_detail_modal {
    position: fixed;
    left: 0;
    top: 0;
    margin: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: #fff;
}

#order_detail_modal .column {
    width: 100%;
    min-Width: 100%;
    max-width: 100%;
}

#order_detail_modal #header {
    padding: 20px 30px;
}

#order_detail_modal #body {
    margin: 80px 0;
    width: 100%;
    font-size: 12px;
    overflow: auto;
}

#order_detail_modal #header {
    padding: 20px 30px;
}

#order_detail_modal #footer {
    padding: 20px 30px;
    background-color: #eee;
}

</style>


// WEBPACK FOOTER //
// src/components/OrderModal_Detail2.vue